// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"a7540e10","73":"ada00134","74":"83fd2a13","453":"1580749f","498":"2f315a87","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};